<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex == 1">
        <BonusView :data-set="dataSet" @pick-mistery-gift="pickMisteryGift" @select-tab="selectTab" />
    </div>
    <div v-if="themeStore.themeIndex == 2">
        <BonusViewTwo :data-set="dataSet" @pick-mistery-gift="pickMisteryGift" @select-tab="selectTab" />
    </div>
    <div v-if="themeStore.themeIndex == 3">
        <BonusViewThree :data-set="dataSet" @pick-mistery-gift="pickMisteryGift" @select-tab="selectTab" />
    </div>
    <div v-if="themeStore.themeIndex == 4">
        <BonusViewFour :data-set="dataSet" @pick-mistery-gift="pickMisteryGift" @select-tab="selectTab" />
    </div>



    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>
<script setup lang="ts">
import { getActivityInformations } from '@/api/common';
import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { getMisteryGift } from '@/api/mystery';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import BonusView from '@/themes/themeOne/bonus/bonusView.vue';
import BonusViewTwo from '@/themes/themeTwo/bonus/bonusView.vue';
import BonusViewThree from '@/themes/themeThree/bonus/bonusView.vue';
import BonusViewFour from '@/themes/themeFour/bonus/bonusView.vue';
import { BonusData, DayItem, MysteryConfig, RewardData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
// activeStatus -: 0- expired, 1 - active(today), 2-upcoming
const userStore = useUserStore()
const isPopping = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()

const activityInfo = ref([])
const rewardDayList = ref([1, 3, 7, 15, 30])
const rewardDayData = ref<Record<number, RewardData>>({})
const mysteryDataConfig = ref<MysteryConfig>({
    activityIntro: '',
    floatIcon: '',
    extraConfig: {
        reward_day_list: []
    },
    config: {
        resultDTO: {},
        user_join_date: 0,
    },
    startTime: 0
})
const dayList = ref<DayItem[]>([])
const selectedTab = ref<any>({})
const bannerIcon = ref('')

const dataSet = computed<BonusData>(() => ({
    isPopping: isPopping.value,
    activityInfo: activityInfo.value,
    rewardDayList: rewardDayList.value,
    rewardDayData: rewardDayData.value,
    mysteryDataConfig: mysteryDataConfig.value,
    dayList: dayList.value,
    selectedTab: selectedTab.value,
    bannerIcon: bannerIcon.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "MYSTERY_DAY_REWARD"
    }

    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        mysteryDataConfig.value = res.data
        bannerIcon.value = mysteryDataConfig.value?.floatIcon
        activityInfo.value = JSON.parse(mysteryDataConfig.value.activityIntro);
        rewardDayList.value = mysteryDataConfig.value.extraConfig.reward_day_list
        rewardDayData.value = mysteryDataConfig.value.config.resultDTO as Record<number, RewardData>

        dayList.value = rewardDayList.value.map((day: number) => ({
            reward_day: day,
            reward_data: rewardDayData.value[day]
        }))
        selectedTab.value = selectObject(dayList.value)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const pickMisteryGift = (activeStatus: number) => {
     loadingRef.value.open()
    let data = {
        uid: userStore.id
    }
    if (activeStatus == 1) {
        isPopping.value = true
        getMisteryGift(data).then(res => {
            if (res.data.code == 'system.success') {
                
                showSuccess('')
                getActivityInfo()
            } else {
                showError(res.data.code)
            }
            loadingRef.value.close()
        }).catch(err => {
            showError(err);
            loadingRef.value.close()
        })
    }
}

const selectTab = (item: any) => {
    selectedTab.value = item
}

function selectObject(arr: any) {
    if (!arr.length) return undefined

    // 1. Find object with activeStatus = 1
    const activeOne = arr.find((obj: any) => obj.reward_data.activeStatus === 1)
    if (activeOne) return activeOne

    // 2. Find last object with activeStatus = 0
    const activeZero = [...arr].reverse().find(obj => obj.reward_data.activeStatus === 0)
    if (activeZero) return activeZero

    // 3. Default to first object
    return arr[0]
}
onMounted(() => {
    getActivityInfo()
})
</script>